import { ACHIEVEMENT_CARD as achievementCard } from './achievementCard';

export const EARN = {
  achievementCard
};
